export default __webpack_public_path__ + "static/SRUS P60 - Product Specifications & Technical Data-8ff019b35faaf3ac45f3df80ed441343.pdf";